import hashSum from 'hash-sum'

export default {
  methods: {
    /**
     * @param value { Any } An arbitrary value that will then be encoded into its own unique hash.
     * @param space { Number } The dimension we want to hash to should be less than or equal to 63
     * @return Number returns a number for the resulting hash siz
     * useful for generating unique vue keys
     * Is currently a vector hash function. But if an even stronger version is needed more can be found here:
     * https://arxiv.org/pdf/1504.06804.pdf
     */
    hash(value) {
      // this._private_a = this?._private_a || [0]
      // this._private_b =
      //   this?._private_b || Math.random() * Number.MAX_SAFE_INTEGER
      // const self = this
      // function h(str) {
      //   let t = 0
      //   // eslint-disable-next-line no-plusplus
      //   for (let i = 0; i < str.length; i++) {
      //     if (self._private_a.length === i) {
      //       const n = Math.random() * Number.MAX_SAFE_INTEGER
      //       // For those that don't know the single & is a bitwise and and the 1 simple checks if the
      //       // least significant bit is one, in which case the number is unequal
      //       // eslint-disable-next-line no-bitwise
      //       self._private_a.push(n & (1 === 0) ? n + 1 : n) // We force our n to be unequal
      //     }
      //     t += str[i].charCodeAt(0) * self._private_a[i]
      //   }
      //   // The >>> is a fancy bitwise right shift only found in js
      //   // eslint-disable-next-line no-bitwise
      //   return (t + self._private_b) >>> (63 - space)
      // }
      // const v = isObject(value) ? JSON.stringify(value) : value
      return hashSum(value)
    },
  },
}
